<template lang="pug">
    div.wrapper
        div(v-if="state === 'loading'")
            h2.o-heading {{ provider }} login
            p.o-paragraph Please wait while we log you in...
            Spinner
        div(v-else-if="state === 'success'")
            p.o-paragraph Successfully logged with {{ provider }}. You'll be redirected shortly...
        div(v-else-if="state === 'error'")
            p.o-paragraph.c-red There was an error logging you in with {{ provider }}.
</template>

<style scoped lang="sass">
.wrapper
  display: flex
  flex-direction: column
  justify-content: center
  align-items: center
  height: 100vh
  text-align: center
</style>

<script>
import Spinner from "src/components/Spinner/Spinner.vue";
import Api from "src/services/api";

export default {
  name: "SocialLogin",
  components: {
    Spinner
  },
  mounted() {
    if (this.state === "loading") {
      this.processLogin();
    }
  },
  methods: {
    async processLogin() {
      const code = this.$route.query.code;
      const stateCode = this.$route.query.state;

      if (!code || !stateCode) {
        this.state = "error";
        return;
      }

      try {
        const response = await Api.OAuthLoginExchange({
          provider: this.provider,
          code: code,
          state: stateCode,
          redirectUrl: window.location.href.split("?")[0]
        });
        this.state = "success";

        // Redirect after a short delay to show the success message
        setTimeout(() => {
          window.location.href = response.redirect_url;
        }, 3000);
      } catch (err) {
        console.error(err);
        this.state = "error";
      }
    }
  },
  data() {
    return {
      state: "loading",
      provider: this.$route.params.provider
    };
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/SocialLogin/SocialLogin.vue